module.exports = __webpack_public_path__ + "media/images/shop/logo-hyper-1fc98f2ccda3307ac18cb8abcfb42736.png";